<div id="content" class="extensible production-kpi-matrix-page">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="filters-panel">
    <mat-button-toggle-group class="mode-toggle" hideSingleSelectionIndicator [value]="selected_mode()" (change)="setMode($event)">
      <mat-button-toggle value="users">Trabajadores</mat-button-toggle>
      <mat-button-toggle value="company_products">Productos</mat-button-toggle>
      <mat-button-toggle value="efficiency">Eficiencia productiva</mat-button-toggle>
    </mat-button-toggle-group>

    @if (!is_efficiency_mode()) {
      <mat-button-toggle-group
        class="evaluation-toggle"
        multiple
        hideSingleSelectionIndicator
        [value]="selected_evaluations()"
        (change)="setEvaluations($event)"
      >
        @for (evaluation of evaluation_options; track evaluation) {
          <mat-button-toggle [value]="evaluation">
            <span class="evaluation-dot" [style.background-color]="evaluation_styles[evaluation].color"></span>
            <span>{{ evaluation_styles[evaluation].label }}</span>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>

      <mat-button-toggle-group
        class="axis-toggle"
        hideSingleSelectionIndicator
        [value]="selected_axis_display()"
        (change)="setAxisDisplay($event)"
      >
        @if (selected_mode() === 'users') {
          <mat-button-toggle value="photo_informal">Foto normal</mat-button-toggle>
          <mat-button-toggle value="photo_formal">Foto formal</mat-button-toggle>
          <mat-button-toggle value="name_and_photo">Nombre y foto</mat-button-toggle>
        } @else {
          <mat-button-toggle value="logo">Solo logo</mat-button-toggle>
          <mat-button-toggle value="logo_and_name">Logo y nombre</mat-button-toggle>
        }
      </mat-button-toggle-group>
    }

    <div class="month-navigation-wrapper">
      <app-month-navigation
        [selected_month]="month_navigation_selected()"
        [display_label]="month_navigation_display_label()"
        [current_button_tooltip]="month_navigation_current_tooltip()"
        [can_go_to_next_month]="can_go_to_next_month()"
        [can_go_to_current_month]="can_go_to_current_month()"
        (previous_month)="goToPreviousMonth()"
        (next_month)="goToNextMonth()"
        (current_month)="goToCurrentMonth()"
      ></app-month-navigation>
    </div>
  </div>

  @if (is_efficiency_mode()) {
    <app-production-efficiency-matrix [from_month]="efficiency_from_month()" [to_month]="efficiency_to_month()" />
  } @else if (is_loading()) {
    <div class="matrix-state">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (error_message()) {
    <div class="matrix-state">
      <p>{{ error_message() }}</p>
    </div>
  } @else {
    @if (view_model(); as view) {
      <div class="matrix-scroll">
        <table class="kpi-matrix-table">
          <thead>
            <tr>
              <th class="sticky-corner sticky-tone"></th>
              <th class="sticky-general-col sticky-header-cell sticky-tone">General</th>
              @for (column of view.columns; track column.id) {
                <th class="sticky-header-cell sticky-tone">
                  <div
                    class="column-header"
                    [class.with-name]="column.show_name"
                    [matTooltip]="column.name_tooltip || ''"
                    [matTooltipDisabled]="!column.name_tooltip"
                  >
                    <img [src]="column.photo_url" [alt]="column.name" class="column-avatar" />
                    @if (column.show_name) {
                      <span class="column-name" [matTooltip]="column.name">{{ column.name }}</span>
                    }
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            <tr class="general-row">
              <th class="sticky-row-label sticky-tone">
                <div class="row-label">
                  <span class="row-label-text">General</span>
                </div>
              </th>
              <td class="sticky-general-col sticky-tone">
                @if (view.global_general_color) {
                  <span class="evaluation-dot" [style.background-color]="view.global_general_color"></span>
                }
              </td>
              @for (column of view.columns; track column.id) {
                <td class="sticky-tone">
                  @if (column.general_color) {
                    <span class="evaluation-dot" [style.background-color]="column.general_color"></span>
                  }
                </td>
              }
            </tr>
            @for (row of view.rows; track row.id) {
              <tr [class.company-product-header-row]="row.kind === 'company_product_header'" [class.child-row]="row.is_child">
                <th class="sticky-row-label sticky-tone">
                  <div class="row-label">
                    @if (row.collapsible) {
                      <button type="button" class="collapse-button" (click)="toggleCompanyProductRow(row.id)">
                        <mat-icon>{{ row.is_collapsed ? 'chevron_right' : 'expand_more' }}</mat-icon>
                      </button>
                      @if (row.show_company_product_logo) {
                        <img [src]="row.company_product_logo_url" [alt]="row.label" class="row-company-product-logo" />
                      }
                    }
                    <span class="row-label-text" [matTooltip]="row.label">{{ row.label }}</span>
                    @if (row.description) {
                      <mat-icon
                        class="kpi-description-icon"
                        [matTooltip]="row.description"
                        matTooltipPosition="above"
                        matTooltipShowDelay="200"
                        >info</mat-icon
                      >
                    }
                  </div>
                </th>
                <td class="sticky-general-col sticky-tone">
                  @if (row.row_general_color) {
                    <span class="evaluation-dot" [style.background-color]="row.row_general_color"></span>
                  }
                </td>
                @for (cell of row.cells; track $index) {
                  <td>
                    @if (row.cell_layout === 'members_grid') {
                      <div class="members-cell">
                        <div class="members-summary">
                          @if (cell.color) {
                            <span class="evaluation-dot" [style.background-color]="cell.color"></span>
                          }
                        </div>
                        <div class="members-grid">
                          @for (member of cell.members; track member.user_id) {
                            <button
                              type="button"
                              class="member-avatar-button"
                              [style.border-color]="member.border_color"
                              [matTooltip]="member.tooltip || ''"
                              [matTooltipDisabled]="!member.tooltip"
                              (click)="openMemberDetail(cell, member)"
                            >
                              <img [src]="member.photo_url" [alt]="member.name || ''" />
                            </button>
                          }
                        </div>
                      </div>
                    } @else if (cell.clickable) {
                      <button
                        type="button"
                        class="cell-button"
                        [matTooltip]="cell.tooltip || ''"
                        [matTooltipDisabled]="!cell.tooltip"
                        (click)="openCellDetail(cell)"
                      >
                        @if (cell.color) {
                          <span class="evaluation-dot" [style.background-color]="cell.color"></span>
                        }
                      </button>
                    } @else if (cell.color) {
                      <span
                        class="evaluation-dot"
                        [style.background-color]="cell.color"
                        [matTooltip]="cell.tooltip || ''"
                        [matTooltipDisabled]="!cell.tooltip"
                      ></span>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>
